import React from "react";
import {Slider, TextField, Typography} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import Box from "@mui/material/Box";

interface StyledSliderProps {
    value: number;
    onChange(event: Event, newValue: number[] | number, activeThumb: number): void
    valueLabelDisplay: 'auto' | 'off' | 'on'
    formatLabel: (value: number) => string
    min: number,
    max: number,
    labelSlider?: string;
    includeInputText?: boolean;
    inputTextLabel?: string;
    step?: number;
    disabled?: boolean;
}

const StyledSlider: React.FC<StyledSliderProps> = ({ value, onChange, valueLabelDisplay, formatLabel, min, max, labelSlider, inputTextLabel, includeInputText, step, disabled = false}) => {

    const theme = useTheme();

    function handleInputChange(event: React.ChangeEvent<HTMLInputElement>){
        const tempValue = Number(event.target.value)
        if (!isNaN(tempValue)) {
            if (tempValue === 0 ) {
                onChange(event as any, ("" as any), 0)
            } else if (tempValue > max) {
                onChange(event as any, max, 0)
            }else if (tempValue < min) {
                onChange(event as any, min, 0)
            }else{
                onChange(event as any,  tempValue, 0)
            }
        }
    }

    return (
        <Box sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            display: 'flex',
            gap: '5px',
        }}>

        <Typography gutterBottom sx={{
            color: theme.palette.white,
            minWidth: '200px'
        }}>
            {labelSlider}
        </Typography>

        <Slider
            value={value}
            onChange={onChange}
            valueLabelDisplay={valueLabelDisplay}
            valueLabelFormat={formatLabel}
            min={min}
            max={max}
            step={step}
            disabled={disabled}
            sx={{color: 'green', // Color for the thumb and track when active
                '& .MuiSlider-thumb': {
                    backgroundColor: theme.palette.orange,   // Thumb color
                },
                '& .MuiSlider-track': {
                    backgroundColor: theme.palette.orange, // Track color
                },
                '& .MuiSlider-rail': {
                    backgroundColor: theme.palette.lightGrey,   // Inactive track (rail) color
                },}}
        />
            {includeInputText &&
                <Box display={'flex'} alignItems={'center'}>
                    <TextField
                        value={value}
                        onChange={handleInputChange}
                        variant="standard"
                        type="number"
                        disabled={disabled}
                        inputProps={{
                            min: min,
                            max: max,
                            step: step,
                        }}
                        sx={{ width: 50,
                            '& .MuiInputBase-input': {
                                textAlign: 'center',
                                color: theme.palette.white,
                            },
                            '& .MuiInputBase-input.Mui-disabled': {
                                color: theme.palette.white,
                                WebkitTextFillColor: theme.palette.white,
                                opacity: 1,
                            },
                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0,
                            },
                            // Remove arrows in Firefox
                            '& input[type=number]': {
                                MozAppearance: 'textfield',
                            },
                        }}
                    />
                    {<Typography sx={{color: theme.palette.white}}>{inputTextLabel}</Typography>}
                </Box>
            }
    </Box>
    )
}

export default StyledSlider;